module.exports = __webpack_public_path__ + "media/images/ic-pin-azul-b742a9fb54974e12a6da5df50835e330.svg";